var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaIconGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wa-icon--green-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Pro-14\"-Copy",
    transform: "translate(-278, -512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wa-icon--green-2",
    transform: "translate(278, 512)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EDEDED",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "wa-icon--white",
    transform: "translate(11, 11)",
    fill: "#82BC00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.557,25.777 L13.551,25.777 C11.301,25.776 9.091,25.235 7.127,24.208 L0,26 L1.907,19.324 C0.732887273,17.3807425 0.11251418,15.1534163 0.113,12.883 C0.116,5.779 6.146,0 13.556,0 C17.153,0.001 20.528,1.343 23.066,3.778 C25.604,6.214 27.001,9.451 27,12.893 C26.997,19.995 20.969,25.773 13.557,25.777 Z M7.457,21.876 L7.865,22.108 C9.59975306,23.0888579 11.5591515,23.603256 13.552,23.6010074 L13.557,23.6010074 C19.715,23.6010074 24.727,18.797 24.7300006,12.892 C24.731,10.031 23.57,7.341 21.46,5.316 C19.35,3.292 16.545,2.177 13.56,2.176 C7.398,2.176 2.385,6.979 2.38299873,12.884 C2.382,14.907 2.973,16.878 4.091,18.582 L4.357,18.988 L3.227,22.939 L7.457,21.876 Z M20.329,15.956 C20.245,15.822 20.021,15.742 19.686,15.581 C19.35,15.42 17.698,14.641 17.39,14.533 C17.082,14.426 16.858,14.373 16.634,14.694 C16.411,15.017 15.767,15.742 15.571,15.957 C15.375,16.171 15.179,16.198 14.843,16.037 C14.507,15.877 13.425,15.537 12.142,14.439 C11.143,13.586 10.469,12.532 10.273,12.209 C10.077,11.887 10.253,11.713 10.42,11.552 C10.571,11.408 10.756,11.176 10.924,10.988 C11.092,10.8 11.148,10.666 11.26,10.451 C11.372,10.236 11.316,10.049 11.232,9.887 C11.148,9.727 10.476,8.142 10.196,7.497 C9.924,6.869 9.646,6.954 9.441,6.945 C9.22645463,6.9360333 9.01173049,6.93203223 8.797,6.933 C8.573,6.933 8.209,7.013 7.901,7.336 C7.593,7.658 6.725,8.437 6.725,10.022 C6.725,11.606 7.929,13.137 8.097,13.352 C8.265,13.567 10.466,16.818 13.835,18.212 C14.637,18.544 15.262,18.742 15.75,18.891 C16.555,19.136 17.287,19.101 17.866,19.018 C18.511,18.926 19.853,18.24 20.133,17.488 C20.413,16.735 20.413,16.091 20.329,15.957 L20.329,15.956 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaIconGreen2);
export default __webpack_public_path__ + "static/media/wa-icon--green-2.cc6e5b62c31c72d59c46a2334d07d2d1.svg";
export { ForwardRef as ReactComponent };